import React from "react";
import Input from "../../../Common/Input/Input";
import DeleteIcon from "../../../Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../Common/ToolTip/Tooltip";
import { useSelector } from "react-redux";
import classes from "./AddSurveyQuestionArr.module.scss";
import { FormattedMessage } from "react-intl";
const AddSurveyQuestionArr = ({
  questionsFields,
  appendQuestion,
  activeQuestionIndex,
  errors,
  setActiveQuestionIndex,
  isValid,
  setActiveTab,
  questionListWatch,
  shotclassType,
  isDistributed,
  trigger,
  isEditQuestion,
  updateQuestion,
  setIsEditQuestion,
  handleDeleteSurveyQuestion,
  disableTabsOnValid,
  setDisableTabsOnValid,
  handleDisableFormValue,
  isScored,
  formValues,
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  console.log("inner disableTabsOnValid", disableTabsOnValid);
  console.log("inner handleDisableFormValue", handleDisableFormValue);
  return (
    <div className={classes.addSurveyQuestionArr__questionFields}>
      {questionsFields.map((question, index, questionArr) => {
        return (
          <React.Fragment key={question.id}>
            {activeQuestionIndex === index ? (
              <div
                className={
                  classes.addSurveyQuestionArr__questionFields__questionField
                }
                key={question.id}
              >
                <Input
                  name={`QuestionsList.${index}.Question`}
                  label="Write Question"
                  labelMsg="(Max : 250 Characters)"
                  placeholder="Enter Survey Question"
                  labelColor="light"
                  error={errors?.QuestionsList?.[index]?.Question?.message}
                  errorPosition="absolute"
                  required={true}
                  type="textarea"
                  maxLength={250}
                  disabled={shotclassType === "view"}
                  onChange={() => {
                    // if (!isValid) {
                    if (
                      errors?.QuestionsList?.message ||
                      errors?.QuestionsList?.[activeQuestionIndex]?.Question
                        ?.message
                      // !isValid
                    ) {
                      trigger([`QuestionsList`]);
                    }
                  }}
                />
                {index !== 0 && !isDistributed && (
                  <Tooltip
                    content={<FormattedMessage id="MYCLASS_DELETE" />}
                    direction="bottom"
                  >
                    <span
                      onClick={() => {
                        if (shotclassType !== "view") {
                          handleDeleteSurveyQuestion(index);
                        }
                      }}
                      className={
                        classes.addSurveyQuestionArr__questionFields__questionField__removeIcon
                      }
                    >
                      <DeleteIcon fill={colors.theme} />
                    </span>
                  </Tooltip>
                )}
                {index === activeQuestionIndex &&
                  !errors?.QuestionsList?.[index]?.Question?.message && (
                    <div
                      className={
                        classes.addSurveyQuestionArr__questionFields__questionField__error
                      }
                    >
                      {errors?.QuestionsList?.message}
                    </div>
                  )}
              </div>
            ) : (
              <div
                className={
                  classes.addSurveyQuestionArr__questionFields__questionField
                }
                key={question.id}
              >
                <div
                  className={
                    classes.addSurveyQuestionArr__questionFields__questionField__question
                  }
                >
                  {index +
                    1 +
                    ". " +
                    questionListWatch?.[index]?.Question +
                    " "}
                  {isScored && (
                    <span>
                      <b>
                        (&nbsp; Max Score :&nbsp;
                        {Math.max(
                          ...questionListWatch[index]?.AnswersList?.map(
                            (choice) => choice?.Score || choice?.Grade || 0
                          )
                        )}
                        &nbsp;)
                      </b>
                    </span>
                  )}
                </div>
                {activeQuestionIndex === -1 && (
                  <div
                    className={
                      classes.addSurveyQuestionArr__questionFields__questionField__options
                    }
                  >
                    <Tooltip
                      content={<FormattedMessage id="MYCLASS_EDIT" />}
                      direction="bottom"
                    >
                      <div
                        onClick={() => {
                          setIsEditQuestion(true);
                          setActiveQuestionIndex(() => index);
                          setActiveTab(
                            () => questionListWatch?.[index]?.ActiveQuestionType
                          );
                        }}
                        className={
                          classes.addSurveyQuestionArr__questionFields__questionField__options__icon
                        }
                      >
                        <EditIcon />
                      </div>
                    </Tooltip>
                    {!isDistributed && (
                      <Tooltip
                        content={<FormattedMessage id="DELETE_TXT" />}
                        direction="bottom"
                      >
                        <div
                          onClick={() => {
                            if (shotclassType !== "view") {
                              handleDeleteSurveyQuestion(index);
                            }
                          }}
                          className={
                            classes.addSurveyQuestionArr__questionFields__questionField__options__icon
                          }
                        >
                          <DeleteIcon />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
            )}
            {index === activeQuestionIndex && !isScored && (
              <div
                className={
                  classes.addSurveyQuestionArr__questionFields__freeFormTextBox
                }
              >
                <Input
                  type="checkbox"
                  name={`QuestionsList.${index}.IsFreeFormTextBox`}
                  label="Is a free form text box ?"
                  labelColor="dark"
                  direction="row"
                  width="2"
                  height="2"
                  disabled={
                    isEditQuestion ||
                    disableTabsOnValid ||
                    handleDisableFormValue
                    // shotclassType === "view" || shotclassType === "edit"
                  }
                  onChange={(e) => {
                    const updatedQuestion = {
                      Question:
                        questionListWatch?.[activeQuestionIndex]?.Question,
                      ActiveQuestionType: 1,
                      MultiSelect: false,
                      AnswersList: [{ Answer: "" }, { Answer: "" }],
                      IsFreeFormTextBox: e.target.checked,
                    };
                    updateQuestion(activeQuestionIndex, updatedQuestion);
                    setActiveTab(() => 1);
                  }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AddSurveyQuestionArr;
